// What the annotator had on screen, for the event log.
//
// The Min/Max window and its curve only ever lived in the browser, so nothing recorded which
// rendering of a frame an outline was drawn against. For a published dataset that is part of the
// method: the same 16-bit frame shows different structures at different windows. The snapshot is
// attached to the annotation events (and sent on its own when the window changes), which puts it
// into ClickHouse next to the job, frame and user it belongs to.

import { getCVATStore } from 'cvat-store';
import { CombinedState } from 'reducers';
import { currentGray16 } from 'utils/sixteen-bit';

export interface DisplaySnapshot {
    frame: number;
    // In SOURCE units: 0..level_limit, i.e. camera counts on a 16-bit frame, 0..255 otherwise.
    min: number;
    max: number;
    level_limit: number;
    sixteen_bit: boolean;
    curve: string;
    // Gamma exponent or asinh softness; null on the linear curve, which has no parameter.
    curve_parameter: number | null;
    filters: string[];
    smooth: boolean;
}

export function displaySnapshot(): { display: DisplaySnapshot } {
    const state: CombinedState = getCVATStore().getState();
    const {
        minLevel, maxLevel, levelLimit, displayCurve, gammaLevel, asinhSoftness, smoothImage,
    } = state.settings.player;

    let parameter: number | null = null;
    if (displayCurve === 'gamma') parameter = gammaLevel;
    if (displayCurve === 'asinh') parameter = asinhSoftness;

    return {
        display: {
            frame: state.annotation.player.frame.number,
            min: minLevel,
            max: maxLevel,
            level_limit: levelLimit,
            sixteen_bit: currentGray16() !== null,
            curve: displayCurve,
            curve_parameter: parameter,
            filters: state.settings.imageFilters.map((imageFilter) => imageFilter.alias),
            smooth: smoothImage,
        },
    };
}
